export default __webpack_public_path__ + "static/media/close.2a892ed2.svg";